
import React, { useState, useRef,useEffect } from 'react';


function App() {
  const [selectedCountry, setSelectedCountry] = useState('');

  const getCookie = (name) => {

    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.trim().split('=');
        if (cookieName === name) {
          return cookieValue;
        }
      }
      return null;
    };
  
  
    const [isChatboxOpen, setChatboxOpen] = useState(false);
    const [socket, setSocket] = useState(null);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [sessionId,setSessionId]=useState()
    const [newUser, setNewUser] = useState(() => {
      const cookieValue = getCookie('new_user');
      return cookieValue === "true";
    });

    const handleCountryChange = (e) => {
      setSelectedCountry(e.target.value);
    };

    const countryOptions =  ['Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Australia',
    'Austria',
    'Azerbaijan',
    'The Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bhutan',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Brazil',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Comoros',
    'Congo, Democratic Republic of the',
    'Congo, Republic of the',
    'Costa Rica',
    'Côte d’Ivoire',
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'East Timor (Timor-Leste)',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Eswatini',
    'Ethiopia',
    'Fiji',
    'Finland',
    'France',
    'Gabon',
    'The Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Greece',
    'Grenada',
    'Guatemala',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Honduras',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Korea, North',
    'Korea, South',
    'Kosovo',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Micronesia, Federated States of',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Morocco',
    'Mozambique',
    'Myanmar (Burma)',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'North Macedonia',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Qatar',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Sudan, South',
    'Suriname',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Togo',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Vatican City',
    'Venezuela',
    'Vietnam',
    'Yemen',
    'Zambia',
    'Zimbabwe']
  
    
   
  

    
  
  
  
    const [messages,setMessages]=useState([])
    const inputRef = useRef(null);
    const [waiting,setWaiting]=useState(false)
    const [client_name,setClientName]=useState("")
    const [user_mail,setUsermail]=useState("")
    const [country,setCountry]=useState("")
    const [phone,setPhone]=useState("")
    const [country_code,setCountryCode]=useState("")
  
  
    const handleNameChange = (e) => {
      setClientName(e.target.value);
    };
  
    const handleEmailChange = (e) => {
      setUsermail(e.target.value);
    };
  
    const handlePhoneChange = (e) => {
      setPhone(e.target.value);
    };
  

      const handleCountrycode = (e) => {
      setCountryCode(e.target.value);
    };
  

    const jaweb_obj=[{
      id:1,
      item:'Enterprise',
      src:'https://www.jaweb.me/static/media/7273530.de83bbe5853cfa809f5c.png',
      description:'Book a Demo'

    },
  
    {
      id:2,
      item:'Web Access',
      src:'https://www.jaweb.me/static/media/icone-internet-violet.684f9ff545a86ca1900f.png',
      description:'$30/month'

    }
  ]
  
  
  const setCookie = (name, value, days) => {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + days * 24 * 60 * 60 * 1000);
  
    const expires = `expires=${expirationDate.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
  };
  
    // Helper function to generate a unique session ID (you can use your preferred method)
    const generateUniqueSessionId = () => {
      // Implement your own logic to generate a unique session ID (e.g., using a library)
      // For simplicity, using a random string in this example
      return 'session_' + Math.random().toString(36).substring(7);
    };
  
  
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
  
    window.addEventListener('resize', handleResize);
  
    // Session logic
    // const sessionId = ;
  
    if (!getCookie('session_id')) {
    
      const sessionId = generateUniqueSessionId();
      setCookie('session_id', sessionId, 1); 
      setSessionId(sessionId)
      setNewUser(true)
      setCookie('new_user',true,1)
  
    } else {
      console.log('Returning user with session_id:', sessionId);
    }
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [sessionId]);
  
  
    const messagesRef = useRef(null);
  
    // Function to scroll to the bottom of the messages
    const scrollToBottom = () => {
      if (messagesRef.current) {
        messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
      }
    };
  
    const handleButtonClick = () => {
      setChatboxOpen(!isChatboxOpen);
    };
  
  
        const apiCall = async (userMessage) => {
        try {
    
   

          const response = await fetch('https://jawebcrm.onrender.com/api/message-create/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ 
              message: userMessage,
              isBusiness:true,
              session_id:getCookie('session_id'),
              organization:getCookie('company_username'),
              message_history:JSON.parse(getCookie('chatbot_message_history'))
              }),
          });
  
          if (response.ok) {
            const data = await response.json();
            console.log(data)

  
  

            if (data.message_history){
             
              setCookie('chatbot_message_history', JSON.stringify(data.message_history), 1);
              setMessages((prevMessages) => [
                ...prevMessages,
                { role: 'assistant',content: data.message,isBusiness:false},
              ]);

              if (socket && socket.readyState === WebSocket.OPEN) {
                const additionalData = { isBusiness: false,isAi:true };
                const messagePayload = JSON.stringify({
                  message: data.message,
                  additionalData: additionalData,
                });
                socket.send(messagePayload);
        
          
              }


              
            }

        
           
            setWaiting(false)
  
            scrollToBottom()

          } else {
           
            console.error('Failed to fetch data from the API');
            setWaiting(false)
            apiCall(userMessage)
          }
        } catch (error) {
          console.error('Error occurred while fetching data:', error);
          setWaiting(false)
          // apiCall(userMessage)
        }
  
        // Clear the input field
  
      }
  
  
  
      const apiCallChatlog = async () => {
        setWaiting(true)
        try {
          // Make a real API call (replace with your actual API endpoint)
          const response = await fetch('https://jawebcrm.onrender.com/api/chatlog-create/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ name: client_name, isActive: true,user_session_id: getCookie("session_id") , company_username: getCookie('company_username'), mail: user_mail,country:selectedCountry,phone:phone,country_code:country_code}),
  
          });
            
  
          if (response.ok) {
            const data = await response.json();

   
            setCookie("new_user",false,1)
            setNewUser(!getCookie('new_user'))
            setWaiting(false)

            
            setCookie('chatbot_message_history', JSON.stringify(data.obj), 1);
      
  
          } else {
           
            console.error('Failed to fetch data from the API');
            setWaiting(false)
            apiCallChatlog()
          }
        } catch (error) {
          console.error('Error occurred while fetching data:', error);
          setWaiting(false)
      
        }
  
        // Clear the input field
  
      }


      // const [socket, setSocket] = useState(null);
      const [secondSocket, setSecondSocket] = useState(null);
    
      // ... (rest of your component code)
    
      useEffect(() => {
        const initializeWebSocket = (url, onMessageCallback) => {
          const newSocket = new WebSocket(url);
          newSocket.onopen = () => {
            console.log(`WebSocket connection opened for ${url}`);
            if (onMessageCallback) {
              newSocket.onmessage = onMessageCallback;
            }
          };
    
          newSocket.onclose = (event) => {
            console.log(`WebSocket connection closed for ${url}:`, event.reason);
          };
    
          return newSocket;
        };
    
        // Initialize the first WebSocket
        const firstSocketUrl = `wss://jawebcrm.onrender.com/ws/chat/${getCookie('session_id')}/`;
        const firstSocketMessageCallback = (event) => {
          const data = JSON.parse(event.data);
          const message = data.message;
          const isBusiness = data.additionalData.isBusiness;
    
          // Handle messages for the first WebSocket
          if (isBusiness === true || data.additionalData.isAi) {
            // Handle business-related messages or AI messages
          } else {
            // Handle user-related messages
            setMessages((prevMessages) => [
              ...prevMessages,
              { role: 'assistant', content: message, isBusiness: false },
            ]);
          }
        };
    
        const firstSocket = initializeWebSocket(firstSocketUrl, firstSocketMessageCallback);
        setSocket(firstSocket);
    
        // Initialize the second WebSocket
        const secondSocketUrl = `wss://jawebcrm.onrender.com/ws/user/${getCookie('company_username')}/`;
        const secondSocketMessageCallback = (event) => {
          const data = JSON.parse(event.data);
          const message = data.message;
    
          // Handle messages for the second WebSocket
        };
    
        const secondSocket = initializeWebSocket(secondSocketUrl, secondSocketMessageCallback);
        setSecondSocket(secondSocket);
    
        // Clean up WebSocket connections on component unmount
        return () => {
          if (firstSocket) {
            firstSocket.close();
          }
          if (secondSocket) {
            secondSocket.close();
          }
        };
      }, []); 


      // useEffect(() => {
      //   const newSocket = new WebSocket(`wss://jawebcrm.onrender.com/ws/chat/${getCookie('session_id')}/`);
      //   newSocket.onopen = () => {
      //     console.log('WebSocket connection opened');
      //     setSocket(newSocket);
      //   };

      //   console.log(client_name)
    
      //   newSocket.onmessage = (event) => {
      //     const data = JSON.parse(event.data);
      //     const message = data.message;
      //     const isBusiness = data.additionalData.isBusiness;
    

      //     if(isBusiness===true | data.additionalData.isAi){
            
      //     }

      //     else{
      //       console.log("isnotbusiness")
      //       console.log(message)
      //       console.log(data.additionalData.isAi)
      //       setMessages((prevMessages) => [
      //         ...prevMessages,
      //         { role: 'assistant', content: message,isBusiness:false},
      //       ]);
      // console.log(messages)
      //     }
    
    
      //   };
    
      //   newSocket.onclose = (event) => {
      //     console.log('WebSocket connection closed:', event.reason);
      //   };
    
      //   return () => {
      //     if (socket) {
      //       socket.close();
      //     }
      //   };

      // }, [sessionId]);




      // const [secondSocket,setSecondsocket] =useState()



      // useEffect(() => {
      //   const newSocket1 = new WebSocket(`wss://jawebcrm.onrender.com/ws/user/${getCookie('company_username')}/`);
      //   newSocket1.onopen = () => {
      //     console.log('WebSocket connection opened');
      //     setSecondsocket(newSocket1);
      //   };

      //   console.log(client_name)
    
      //   newSocket1.onmessage = (event) => {
      //     const data = JSON.parse(event.data);
      //     const message = data.message;
    

  
    
    
      //   };
    
      //   newSocket1.onclose = (event) => {
      //     console.log('WebSocket connection closed:', event.reason);
      //   };
    
      //   return () => {
      //     if (secondSocket) {
      //       secondSocket.close();
      //     }
      //   };

      // }, [sessionId]);
  
  
    const handleKeyPress = async (e) => {
  
      if (e.key === 'Enter') {
  
        const userMessage = e.target.value;


  
        e.target.value = '';

    // Sending message using the second socket
      if (secondSocket && secondSocket.readyState === WebSocket.OPEN) {
        const secondSocketMessage = {
          session_id: getCookie('session_id'),
          // Add other properties specific to the second socket message
        };
        secondSocket.send(JSON.stringify(secondSocketMessage));
      } else {
        console.error('Second WebSocket connection is not open.');
      }

      // Sending message using the first socket
      if (socket && socket.readyState === WebSocket.OPEN) {
        const additionalData = { isBusiness: true };
        const firstSocketMessagePayload = JSON.stringify({
          message: userMessage,
          additionalData: additionalData,
        });
        socket.send(firstSocketMessagePayload);
      } else {
        console.error('First WebSocket connection is not open.');
      }

        setMessages((prevMessages) => [
          ...prevMessages,
          { role: 'user', content: userMessage,isBusiness:true },
        ]);

        

        scrollToBottom()
        apiCall(userMessage)

        
  
  
    }

    
  
  
    };



  
  
    const handleSubmit = async ()=>{
      apiCallChatlog()
    }
  
  
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 10,
        right: 10,
        zIndex: 999,
      }}
    >
      <button
        style={{
          borderRadius: 30,
          background: '#7f2ef8',
          padding: 10,
          transition: 'box-shadow 0.3s ease',
          boxShadow: '0 0 0 0 rgba(127, 46, 248, 0)',
        }}
        onClick={handleButtonClick}
        onMouseOver={(e) => (e.currentTarget.style.boxShadow = '0 0 10px 5px #7f2ef8')}
        onMouseOut={(e) => (e.currentTarget.style.boxShadow = '0 0 0 0 rgba(127, 46, 248, 0)')}
      >
        {isChatboxOpen ? (
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M18.601 8.39897C18.269 8.06702 17.7309 8.06702 17.3989 8.39897L12 13.7979L6.60099 8.39897C6.26904 8.06702 5.73086 8.06702 5.39891 8.39897C5.06696 8.73091 5.06696 9.2691 5.39891 9.60105L11.3989 15.601C11.7309 15.933 12.269 15.933 12.601 15.601L18.601 9.60105C18.9329 9.2691 18.9329 8.73091 18.601 8.39897Z" fill="white"></path>
          </svg>
        ) : (
          <img
            src='https://static.ada.support/images/e1f9c0f5-51ce-45e4-8240-41d357ef3ed8.svg'
            alt='Chatbot'
          />
        )}
      </button>
  
      {isChatboxOpen && (
        <div>
          {newUser ? (
         <div
            style={{
              position: 'fixed',
              bottom: windowWidth < 768 ? '20%': '10%',
              // top:windowWidth < 768 ? '1%' : '5%',
              right: windowWidth < 768 ? 0 : 10, // Adjust the breakpoint as needed
              // right: 10,
              background: 'white',
              paddingInline: 10,
              paddingTop: 10,
              height:  windowWidth < '50%' ? 0 : '80%',
              borderRadius: 10,
              width: windowWidth < 768 ? '100%' : '25%', // Adjust the breakpoint as needed
              zIndex:999,
  
            }}
          >
            <div
              style={{
                background: '#ECF0F1',
                width: '100%',
                height: '10%',
                borderRadius: 10,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',

                padding: 10,
                justifyContent: 'space-between'
              }}
            >
              <div>
              {waiting?(
        <div style={{marginTop:10,marginBottom:10,justifyContent:'center',alignItems:'center',display:'flex'}}>
       
        <span className="typing-indicator-dot"></span>
        <span className="typing-indicator-dot"></span>
        <span className="typing-indicator-dot"></span>
    </div>
  
          ):(
              <div>
        <p style={{ fontWeight: '400', fontSize: 16 }}>
      
                </p>
              </div>
          )}
    
          
              </div>
              <div>
                <p style={{ fontWeight: '400', fontSize: 26 }}>  👋</p>
              </div>
            </div>
              
  
  <div>
  <form style={{ display: 'block', maxWidth: '300px', margin: '0 auto' }}>
    
  <div  className="relative w-full min-w-[200px] h-10 mt-9">
      <input
        className="peer w-full h-full bg-transparent text-blue-gray-700 font-sans font-normal outline outline-0 focus:outline-0 disabled:bg-blue-gray-50 disabled:border-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 border focus:border-2 focus:border-t-transparent text-sm px-3 py-2.5 rounded-[7px] border-blue-gray-200 focus:border-purple-500"
        placeholder=" "
        onChange={handleNameChange}
        /><label
        className="flex w-full h-full select-none pointer-events-none absolute left-0 font-normal !overflow-visible truncate peer-placeholder-shown:text-blue-gray-500 leading-tight peer-focus:leading-tight peer-disabled:text-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500 transition-all -top-1.5 peer-placeholder-shown:text-sm text-[11px] peer-focus:text-[11px] before:content[' '] before:block before:box-border before:w-2.5 before:h-1.5 before:mt-[6.5px] before:mr-1 peer-placeholder-shown:before:border-transparent before:rounded-tl-md before:border-t peer-focus:before:border-t-2 before:border-l peer-focus:before:border-l-2 before:pointer-events-none before:transition-all peer-disabled:before:border-transparent after:content[' '] after:block after:flex-grow after:box-border after:w-2.5 after:h-1.5 after:mt-[6.5px] after:ml-1 peer-placeholder-shown:after:border-transparent after:rounded-tr-md after:border-t peer-focus:after:border-t-2 after:border-r peer-focus:after:border-r-2 after:pointer-events-none after:transition-all peer-disabled:after:border-transparent peer-placeholder-shown:leading-[3.75] text-blue-gray-400 peer-focus:text-purple-500 before:border-blue-gray-200 peer-focus:before:!border-purple-500 after:border-blue-gray-200 peer-focus:after:!border-purple-500">
        Name
      </label>
    </div>
  
    <div className="relative w-full min-w-[200px] h-10 mt-9">
      <input
        className="peer w-full h-full bg-transparent text-blue-gray-700 font-sans font-normal outline outline-0 focus:outline-0 disabled:bg-blue-gray-50 disabled:border-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 border focus:border-2 border-t-transparent focus:border-t-transparent text-sm px-3 py-2.5 rounded-[7px] border-blue-gray-200 focus:border-purple-500"
        placeholder=" "
        onChange={handleEmailChange}
        /><label
        className="flex w-full h-full select-none pointer-events-none absolute left-0 font-normal !overflow-visible truncate peer-placeholder-shown:text-blue-gray-500 leading-tight peer-focus:leading-tight peer-disabled:text-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500 transition-all -top-1.5 peer-placeholder-shown:text-sm text-[11px] peer-focus:text-[11px] before:content[' '] before:block before:box-border before:w-2.5 before:h-1.5 before:mt-[6.5px] before:mr-1 peer-placeholder-shown:before:border-transparent before:rounded-tl-md before:border-t peer-focus:before:border-t-2 before:border-l peer-focus:before:border-l-2 before:pointer-events-none before:transition-all peer-disabled:before:border-transparent after:content[' '] after:block after:flex-grow after:box-border after:w-2.5 after:h-1.5 after:mt-[6.5px] after:ml-1 peer-placeholder-shown:after:border-transparent after:rounded-tr-md after:border-t peer-focus:after:border-t-2 after:border-r peer-focus:after:border-r-2 after:pointer-events-none after:transition-all peer-disabled:after:border-transparent peer-placeholder-shown:leading-[3.75] text-blue-gray-400 peer-focus:text-purple-500 before:border-blue-gray-200 peer-focus:before:!border-purple-500 after:border-blue-gray-200 peer-focus:after:!border-purple-500">
        Email
      </label>
    </div>

  
  <div className="relative w-full min-w-[200px] h-10 mt-9">
      <input
        className="peer w-full h-full bg-transparent text-blue-gray-700 font-sans font-normal outline outline-0 focus:outline-0 disabled:bg-blue-gray-50 disabled:border-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 border focus:border-2 border-t-transparent focus:border-t-transparent text-sm px-3 py-2.5 rounded-[7px] border-blue-gray-200 focus:border-purple-500"
        placeholder=" " 
        onChange={handlePhoneChange}
        /><label
        className="flex w-full h-full select-none pointer-events-none absolute left-0 font-normal !overflow-visible truncate peer-placeholder-shown:text-blue-gray-500 leading-tight peer-focus:leading-tight peer-disabled:text-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500 transition-all -top-1.5 peer-placeholder-shown:text-sm text-[11px] peer-focus:text-[11px] before:content[' '] before:block before:box-border before:w-2.5 before:h-1.5 before:mt-[6.5px] before:mr-1 peer-placeholder-shown:before:border-transparent before:rounded-tl-md before:border-t peer-focus:before:border-t-2 before:border-l peer-focus:before:border-l-2 before:pointer-events-none before:transition-all peer-disabled:before:border-transparent after:content[' '] after:block after:flex-grow after:box-border after:w-2.5 after:h-1.5 after:mt-[6.5px] after:ml-1 peer-placeholder-shown:after:border-transparent after:rounded-tr-md after:border-t peer-focus:after:border-t-2 after:border-r peer-focus:after:border-r-2 after:pointer-events-none after:transition-all peer-disabled:after:border-transparent peer-placeholder-shown:leading-[3.75] text-blue-gray-400 peer-focus:text-purple-500 before:border-blue-gray-200 peer-focus:before:!border-purple-500 after:border-blue-gray-200 peer-focus:after:!border-purple-500">
        Phone
      </label>
    </div>


<div className="relative w-full min-w-[200px] h-10 mt-9">

      <select
        value={selectedCountry}
        onChange={handleCountryChange}
        className="peer w-full h-full bg-transparent text-blue-gray-700 font-sans font-normal outline outline-0 focus:outline-0 disabled:bg-blue-gray-50 disabled:border-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 border focus:border-2  text-sm px-3 py-2.5 rounded-[7px] border-blue-gray-200 focus:border-purple-500"
      >
        <option value="" disabled hidden className='mb-6'>
          Select a country
        </option>
        {countryOptions.map((country, index) => (
          <option key={index} value={country}>
            {country}
          </option>
        ))}
      </select>
  
    </div>
  
  
  
    <div>
      <button
        type="button"
        onClick={handleSubmit}
        style={{
          backgroundColor: '#7f2ef8',
          color: 'white',
          padding: '10px',
          borderRadius: '5px',
          border: 'none',
          cursor: 'pointer',
          width: '100%',
          marginTop:'40px'
  
        }}
      >
        Submit
      </button>
    </div>
  </form>
  
  </div>
          </div>
  
  
          ) : (
            // Content for returning users
            <div
            style={{
              position: 'fixed',
              bottom: windowWidth < 768 ? '20%': '10%',
              // top:windowWidth < 768 ? '1%' : '5%',
              right: windowWidth < 768 ? 0 : 10, // Adjust the breakpoint as needed
              // right: 10,
              background: 'white',
              paddingInline: 10,
              paddingTop: 10,
              height:  windowWidth < '50%' ? 0 : '80%',
              borderRadius: 10,
              border:'1px solid #EDE2F5',
              width: windowWidth < 768 ? '100%' : '25%', // Adjust the breakpoint as needed
              zIndex:999,
  
            }}
          >
            <div
              style={{
                background: '#F2F0F4',
                width: '100%',
                height: '10%',
                borderRadius: 10,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                padding: 10,
                justifyContent: 'space-between',
                border: '1px solid #e1e1e5',
              }}
            >
              <div>
              {waiting?(
        <div style={{marginTop:10,marginBottom:10,justifyContent:'center',alignItems:'center',display:'flex'}}>
       
        <span className="typing-indicator-dot"></span>
        <span className="typing-indicator-dot"></span>
        <span className="typing-indicator-dot"></span>
    </div>
  
          ):(
              <div>
                   <img
      style={{
        border: '1px solid #7f2ef8',
        width:40,
        height:40,
        borderRadius:'50%' // 2px width, solid border with purple color
      }}
      src='https://www.shutterstock.com/image-vector/chat-bot-logo-design-concept-600nw-1938811039.jpg'
      alt="Logo"
    />
              </div>
          )}
    
          
              </div>
      
            </div>
              
  
            <div
    style={{
      height: '80%',
      overflowY: 'scroll',
      padding: 10,
    }}
    ref={messagesRef}
  >
<div style={{
  display: 'flex',
  flexDirection: 'row',
  gap:10,
  width: '100%',
  // justifyContent:'center',
  padding:10,
  // height: '30%',
  height:'auto',
  overflowX: 'scroll',
  marginBottom: 20,
}}>


</div>

      {messages.map((message, index) => (
          <div key={index} style={{ marginBottom: 10 }}>
          {message.isBusiness  ? (
              <div style={{
              padding: 8,
              borderRadius: 5,
              background: '#7f2ef8',
              color: 'white',
              }}>
              <p>{message.content}</p>
              </div>
          ) : (

              <div style={{
              padding: 8,
              borderRadius: 5,
              background: '#f0f0f0',
              color: 'black',
              }}>
              <p>{message.content}</p>
  
              
          
              </div>
  
          )}
          </div>
      ))}
      </div>
            <div style={{display:'flex',alignItems:'center',width:'100%'}}>
              <div style={{width:'100%'}}>
              <input
                ref={inputRef}
                type='text'
                style={{
                  width: '100%',
                  border: '1px solid #e1e1e5',
                  background: '#f3f3f3',
                  // marginTop: 20,
                  padding: 10,
                  color: '#444',
                  borderRadius: 15,
                  fontSize:16,
                  lineHeight:2
                  
                }}
                placeholder='Send Message ...'
               onKeyDown={handleKeyPress}
               disabled={waiting}
              />

                </div>
                <div style={{width:'5%',marginLeft:'-30px'}}>
                  {/* <button onClick={handlesendMessage} disabled={waiting} > 
                  <svg   xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="_svg_1cum9_1 "><path d="M19.5656 12.5913C19.4092 12.9268 19.1426 13.1929 18.8233 13.3529L6.75036 19.4461C5.89387 19.8649 4.86032 19.5233 4.42563 18.6844C4.2343 18.2793 4.19549 17.822 4.32795 17.3955L5.64831 13.0972C5.7692 12.7037 6.13274 12.435 6.54448 12.435H11.1654C11.505 12.4337 11.7828 12.1592 11.7905 11.8101C11.7884 11.4663 11.514 11.1885 11.1654 11.1851H6.54788C6.13452 11.1851 5.76995 10.9144 5.65042 10.5187L4.34749 6.20514C4.07489 5.3055 4.58948 4.34594 5.50008 4.07643C5.92157 3.94393 6.37753 3.98415 6.76989 4.19362L18.8233 10.2868C19.6653 10.7168 20.0041 11.7517 19.5656 12.5913Z" fill="#7f2ef8"></path></svg>
                  </button> */}
                </div>

            </div>
          </div>
  
  
          )}
        </div>
      )}
    </div>
  );
   
  };
export default App;
